import { appState } from '../../AppState';
import { TicketProps } from '../interfaces/ticketproperties.interface';
import { STATUS_GUID, STATUS_VALUE } from '../utils/constants';
import { getStatusIdByGuidHelper, getTicketsFilterQuery } from '../utils/helper';
import { ticketSearchFilter } from '../utils/ticketSearchFilter';

type Filter = { [key: number]: FilterType };

export const useTicketsPQ = () => {
  const state = appState();
  const getStatusId = (statusValue: string) => {
    return state.ticketStatus.find((status: TicketProps) => {
      return status.Guid === statusValue;
    })?.Id;
  };

  const filter: Filter = {
    0: { Closed: [false], Resolved: [false] }, // 'Status/Value': ['Active', 'Pending']
    1: {
      Closed: [false], // 'Status/Value': ['Active', 'Pending']
      AssigneeId: [state.currentUserId], 
      Resolved: [false]
    },
    2: {
      Closed: [false], // 'Status/Value': ['Active', 'Pending']
      AssigneeId: [null],
      Resolved: [false]
    },
    3: { StatusId: [getStatusId(STATUS_GUID.CLOSED), getStatusId(STATUS_GUID.RESOLVED)] }, //  'Status/Value': ['Closed']
    4: { StatusId: [getStatusId(STATUS_GUID.DEFLECTED)] } // 'Status/Value': ['Deflected']
  };

  // converting object into query
  const _getFilterQuery = (customViewsEnabled: boolean, filterObj: FilterType, _searchText: string) => {
    // initially filterObj contains all values of dropdown filters as empty array
    let filterQuery = customViewsEnabled ? undefined : getTicketsFilterQuery(filterObj, state.ticketStatus);

    filterQuery = _searchText
      ? `${ticketSearchFilter(_searchText, { matchId: true, comments: 'all' })}${
          filterQuery ? ` and ${filterQuery}` : ''
        }`
      : filterQuery;

    return filterQuery;
  };

  const getParentFiltersQuery = (customViewsEnabled: boolean, _filterNumber: number, _text: string) => _getFilterQuery(customViewsEnabled,filter[_filterNumber], _text)

  return { getParentFiltersQuery };
};
